import { Component, OnInit, Injector, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'auth-base',
  templateUrl: 'auth.component.html',
  styleUrls: ['auth.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AuthComponent implements OnInit {
  public AuthSubject: string;

  constructor(private router: Router) {
    
  }
  
  ngOnInit() {
  }

  public onNavigate(route) {
    this.router.navigate([route]);
  }
}



// WEBPACK FOOTER //
// ./src/app/_authentication/auth.component.ts